export default __webpack_public_path__ + "static/media/Brasilia Helicoptero-377_tratada.bcc41321.jpg";